import {Matcher} from '@/lib/axiosAddTransforms'
import {cloneDeep} from 'lodash'

const matchers: Matcher[] = [
  {
    test: /^\/invoice-preview\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId} = payload.params
        payload.url = `/bizs/${bizId}/transactions/invoice-preview`
        delete payload.params.bizId
        payload.data = {
          ...payload.data,
          detail: payload.data.detail?.map((item) => itemRequest(item))
        }
        return payload
      },
      response: (data) => {
        if(!data) {
          return {}
        }
        return data
      },
    },
  },
  {
    test: /^\/invoice\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {bizId} = payload.params
        payload.url = `/bizs/${bizId}/transactions/invoice`
        delete payload.params.bizId
        payload.data = {
          ...payload.data,
          detail: payload.data.detail?.map((item) => itemRequest(item))
        }
        return payload
      },
      response: (data) => {
        if(!data) {
          return {}
        }
        return data
      },
    },
  },
]

const itemRequest = (item) => {
  const itemData = cloneDeep(item)
  delete itemData.totalAmount
  delete itemData.taxFree
  if(!itemData.purchaseDate) {
    delete itemData.purchaseDate
  }
  return itemData
}

export default matchers
